import { Check, X, SkipForward } from "lucide-react";

export default function GuessHistory({ history }) {
  if (!history.length) {
    return (
      <div className="mt-4 text-center text-xs uppercase tracking-widest text-slate-600 font-mono py-4"
           data-testid="guess-history-empty">
        No guesses yet
      </div>
    );
  }
  return (
    <ul className="mt-4 space-y-2" data-testid="guess-history">
      {history.map((h, i) => {
        const base = "flex items-center justify-between px-3 py-2.5 rounded-xl border font-mono text-sm";
        let cls = "bg-slate-900/60 border-slate-800 text-slate-300";
        let icon = <X className="h-4 w-4 text-red-500" />;
        if (h.correct) {
          cls = "bg-emerald-950/40 border-emerald-500/60 text-emerald-200";
          icon = <Check className="h-4 w-4 text-emerald-400" />;
        } else if (h.skipped) {
          cls = "bg-slate-800/40 border-slate-700/50 text-slate-400 italic";
          icon = <SkipForward className="h-4 w-4 text-slate-400" />;
        } else {
          cls = "bg-red-950/25 border-red-900/40 text-red-300";
        }
        return (
          <li key={i} className={`${base} ${cls}`} data-testid={`guess-row-${i}`}>
            <span className="truncate">{h.skipped ? "Skipped" : h.text}</span>
            {icon}
          </li>
        );
      })}
    </ul>
  );
}
